import {
  ChoiceGroup,
  DatePicker,
  DefaultButton,
  Icon,
  Label,
  Panel,
  PanelType,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import React, { useCallback } from "react";
import { IRequestTableHistoricoIPERC } from "../../../../Interfaces/IIpercBase";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { onFormatDate } from "../../../../utils/helpers/dateHelpers";
import { ComboBoxIDS } from "../../../../components/generic/ComboBoxIDS";
import { useComboEstados } from "../../../../hooks/combosHooks/useComboEstados";
import { useComboTipoEquipo } from "../../../../hooks/combosHooks/useComboTipoEquipo";
import { useComboModelos } from "../../../../hooks/combosHooks/useComboModelos";
import { useComboEquipos } from "../../../../hooks/combosHooks/useComboEquipos";
import { useComboActividadPorEquipo } from "../../../../hooks/combosHooks/useComboActividadPorEquipo";
import { useComboEquipoIperc } from "../../../../hooks/combosHooks/useComboEquipoIperc";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
interface IPanelSupervisorHistorialFiltro {
  isOpen: boolean;
  onDismiss: () => void;
  onChangeComboBox: (e, o, string) => void;
  onChangeChoiceGroup: (e, o) => void;
  filter: IRequestTableHistoricoIPERC;
  limpiarFiltro: () => void;
  onSelectDate: (date, string) => void;
  fechasFilter: any;
}
export const PanelSupervisorHistorialFiltro = (
  props: IPanelSupervisorHistorialFiltro
) => {
  const { estados } = useComboEstados();
  const {
    _onKeyUpSearchEquipoIperc,
    comboBoxRefEquipoIPERC,
    dataComboEquiposIperc,
    onClickComboBoxEquipoIPERC,
  } = useComboEquipoIperc();
  const {
    dataComboActividad,
    onChangeEquipo,
    _onKeyUpSeaechComboActividad,
    comboBoxRefActividad,
    onClickComboBoxActividad,
  } = useComboActividadPorEquipo();

  // const onRenderFooterPanel = useCallback(
  //   () => (
  //     <>
  //       <div
  //         style={{
  //           display: "flex",
  //           justifyContent: "space-between",
  //           justifyItems: "center",
  //           height: "5%",
  //           padding: "2opx",
  //           margin: "20px",
  //         }}
  //       >
  //         <div style={{ display: "flex" }}>
  //           <PrimaryButton
  //             onClick={() => {
  //               props.limpiarFiltro();
  //             }}
  //             text={"Limpiar Filtro"}
  //           />
  //         </div>
  //         <div style={{ display: "flex" }}>
  //           <DefaultButton
  //             onClick={() => {
  //               props.onDismiss();
  //             }}
  //             text={"Cancelar"}
  //           />
  //         </div>
  //       </div>
  //     </>
  //   ),
  //   [props.onDismiss, props.limpiarFiltro]
  // );
  // const onRenderHeaderPanel = useCallback(
  //   () => (
  //     <>
  //       <PanelHeader
  //         key={"filtrar"}
  //         nameIconHeader="filter"
  //         subTextHeader="Filtrar historico de IPERC de Equipo Trabajo "
  //         textHeader="Filtro Avanzado Historial"
  //       />
  //     </>
  //   ),
  //   []
  // );

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={props.limpiarFiltro}
          disableButton={false}
          onDismiss={props.limpiarFiltro}
        />
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );

  const onRenderHeaderPanel = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro Avanzado Historial de Equipo trabajo"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );


  return (
    <div>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderFooter={onRenderFooterPanel}
        onRenderHeader={onRenderHeaderPanel}
        isFooterAtBottom={true}
        isBlocking={false}
        closeButtonAriaLabel="Close"
        type={PanelType.medium}
        isLightDismiss
      >
        <br />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <DatePicker
                label="Fecha de:"
                placeholder="dd/mm/yyyy"
                ariaLabel="Seleccione una fecha"
                value={props.fechasFilter?.filterFechaInicio}
                onSelectDate={(date?: any) => {
                  props.onSelectDate(date, "inicio");
                }}
                formatDate={onFormatDate}
                maxDate={new Date()}
                underlined
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <DatePicker
                label="a:"
                placeholder="dd/mm/yyyy"
                ariaLabel="Seleccione una fecha"
                value={props.fechasFilter?.filterFechaFin}
                onSelectDate={(date?: any) => {
                  props.onSelectDate(date, "fin");
                }}
                formatDate={onFormatDate}
                maxDate={new Date()}
                underlined
              />
            </div>
          </div>
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <Label id="labelElement">
                <Stack horizontal verticalAlign="center">
                  <span>Estados&nbsp;&nbsp;</span>
                  <Icon iconName="Filter" />
                </Stack>
              </Label>
              <ChoiceGroup
                options={estados}
                selectedKey={props.filter?.estadoId}
                onChange={(e, o) => props.onChangeChoiceGroup(e, o)}
                ariaLabelledBy="labelElement"
              />
            </div>
          </div>
          <br />
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Equipo:"
                componentRef={comboBoxRefEquipoIPERC}
                selectedKey={props.filter?.equipoId}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "equipo");
                  onChangeEquipo(e, o);
                }}
                KeyUp={_onKeyUpSearchEquipoIperc}
                onClick={onClickComboBoxEquipoIPERC}
                options={dataComboEquiposIperc}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Actividad:"
                componentRef={comboBoxRefActividad}
                KeyUp={_onKeyUpSeaechComboActividad}
                selectedKey={props.filter?.actividadId}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "actividad");
                }}
                onClick={onClickComboBoxActividad}
                options={dataComboActividad}
              />
            </div>
          </div>
        </div>
      </Panel>
    </div>
  );
};
